import React from 'react';
import { connect } from 'react-redux';
import { DBTextArea } from '_components';
import { getDateMDYYYY } from '_helpers';
import styles from './Common.module.css';


class PatientCareCenterNoteAssessmentFreeForm extends React.Component {

    render() {
        return (
            <div className={styles.body_wrapper}>
                <span className={styles.row}>
                    <label className={styles.required}>Assessment:</label>
                </span>

                <span className={styles.row}>
                    <DBTextArea
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.ass.ASNO}
                        field='ASFREEFORM'
                        placeholder=''
                        rows={10}
                        className={styles.textarea}
                    />
                    <span className={styles.free_form_tips}>
                        {this.props.flags && this.props.flags.length > 0 &&
                            <>
                                <div>Assessment Flags:</div>
                                <ul>
                                    {Object.keys(this.props.flags)
                                        .map(key => {
                                            const result = this.props.flags[key];
                                            return (
                                                <li key={result.AFNO}>
                                                    {result.AFFLAGTEXT}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </>
                        }
                        {this.props.goals && this.props.goals.length > 0 &&
                            <>
                                <div>Goals:</div>
                                <ul>
                                    {Object.keys(this.props.goals)
                                        .map(key => {
                                            const result = this.props.goals[key];
                                            return (
                                                <li key={result.GONO}>
                                                    {result.label}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </>
                        }
                    </span>
                </span>
                {this.props.prevAss && Date.parse(this.props.prevAss.DOS) > Date.parse('01/01/1970') &&
                    <div className={styles.row}>
                        <label className={styles.prev_ass_label}>{getDateMDYYYY(this.props.prevAss.DOS) + ' Assessment'}</label>
                        <label className={styles.prev_ass}>{this.props.prevAss.ASSESSMENT}</label>
                    </div>
                }
            </div >
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled;
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));
    let ass = state.entities.notes.PTASSESSMENT[asno];
    let diagVal = state.entities.notes.PTASSESSMENT[asno].ASAWAREDIAG !== null ? state.entities.notes.PTASSESSMENT[asno].ASAWAREDIAG === true ? '1' : '2' : undefined;
    let flags = Object.keys(state.entities.notes.PTASSESSMENTFLAGS)
        .filter(key => {
            return state.entities.notes.PTASSESSMENTFLAGS[key].AFASNO === asno;
        })
        .sort((a, b) => { return state.entities.notes.PTASSESSMENTFLAGS[a].AFNO - state.entities.notes.PTASSESSMENTFLAGS[b].AFNO; })
        .map(key => state.entities.notes.PTASSESSMENTFLAGS[key]);

    let selectedFlagLimitations = Object.keys(state.entities.notes.PTASSESSMENTFLAGS)
        .filter(key => {
            return state.entities.notes.PTASSESSMENTFLAGS[key].AFASNO === asno && state.entities.notes.PTASSESSMENTFLAGS[key].AFLIMITATION === true;
        })
        .sort((a, b) => { return state.entities.notes.PTASSESSMENTFLAGS[a].AFNO - state.entities.notes.PTASSESSMENTFLAGS[b].AFNO; })
        .map(key => state.entities.notes.PTASSESSMENTFLAGS[key]);

    let goals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => (
            (state.entities.notes.PTGOALS[key].GOEVNO === pk && noteType === 1) ||
            (state.entities.notes.PTGOALS[key].GONTNO === pk && noteType !== 1))
            && state.entities.notes.PTGOALS[key].GODELETED !== true
            && (state.entities.notes.PTGOALS[key].GOMGNO || state.entities.notes.PTGOALS[key].GOCUSTOM))
        .sort((a, b) => { return state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO; })
        .map(key => {
            let label = '';
            if (state.entities.notes.PTGOALS[key].GOCUSTOM) {
                label = state.entities.notes.PTGOALS[key].GOCUSTOM;
            } else {
                label = state.entities.masterData.PTMASTERGOALS[
                    Object.keys(state.entities.masterData.PTMASTERGOALS)
                        .find(key2 => (state.entities.masterData.PTMASTERGOALS[key2].MGNO === state.entities.notes.PTGOALS[key].GOMGNO))].MGASSESSMENT;
                if (label === 'performing essential job demand' && state.entities.notes.PTGOALS[key].GOWORKTASK) {
                    label += ' (' + state.entities.notes.PTGOALS[key].GOWORKTASK + ')';
                }
            }
            return {
                GONO: state.entities.notes.PTGOALS[key].GONO,
                GODIFFICULT: state.entities.notes.PTGOALS[key].GODIFFICULT,
                label: label
            };
        });

    let selectedGoalDifficulties = Object.keys(goals)
        .filter(key => {
            return (goals[key].GODIFFICULT === true);
        })
        .map(key => goals[key]);


        let prevAssKey = Object.keys(state.entities.notes.PTASSESSMENTPREV)
        .find(key => {
            return (state.entities.notes.PTASSESSMENTPREV[key].NoteId === noteId);
        });
    let prevAss = prevAssKey ? state.entities.notes.PTASSESSMENTPREV[prevAssKey] : undefined;

    return {
        noteId,
        noteType,
        ass,
        isPeds,
        diagVal,
        flags,
        selectedFlagLimitations,
        goals,
        selectedGoalDifficulties,
        prevAss
    };
}

const connectedPatientCareCenterNoteAssessmentFreeForm = connect(mapStateToProps)(PatientCareCenterNoteAssessmentFreeForm);
export { connectedPatientCareCenterNoteAssessmentFreeForm as PatientCareCenterNoteAssessmentFreeForm };

